import { Box } from '@mui/material'
import React from 'react'
import CaseStudiesCard from './CaseStudiesCard'
import { caseStudiesData } from '../../data/CaseStudyCard'

const CaseStudiesCardSection = () => {
  return (
    <Box sx={{
      padding: { xs: "2rem 1.8rem", sm: "1rem 3rem" },
    }}>
      <Box sx={{
        display: 'flex',
        flexWrap: "wrap",
        gap: {xs:'1.5rem',sm:'7rem'},
        justifyContent: "center",
        padding: { xs: '0.2rem', sm: '2rem' },
      }}>
        {caseStudiesData.map((study, index) => (
          <CaseStudiesCard 
            key={index}
            title={study.title}
            id={study.id}
            image={study.image}
            link={study.link}
            description={study.description}
          />
        ))}
      </Box>
    </Box>
  )
}

export default CaseStudiesCardSection
